module.exports = __webpack_public_path__ + "static/livechat2-203b3bdc5a4cf95139253a008bbad0fd.png";